import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppTokenHandler } from '../../common/app-token-handler';
import { environment } from '../../../environments/environment';
import { DataService } from '../../common/data.service';
import { AlertService } from '../../common/alert.service';
import { isNullOrUndefined } from 'util';

enum Roles {
    Finance = 1,
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    menuitems: MenuItem[];
    useritems: MenuItem[];
    subitems: Array<{ label: string, icon: string, routerLink: string }> = [];
    displayPrivacy: boolean = false;

    constructor(private router: Router,
        private appToken: AppTokenHandler,
        private hrservice: DataService,
        private alertService: AlertService) {
    }

    ngOnInit() {
        this.BindMenuItems();
        this.OpenTab();
    }
    CreateNewRequest() {
        this.router.navigate(['/home/new']);
    }
    OpenTab() {
        this.hrservice.GetData('GetPrivacyDetail').subscribe(
            (data: any) => {
                if (isNullOrUndefined(data)) {
                    this.displayPrivacy = true;
                } else {
                    this.displayPrivacy = false;
                }
            }, _error => {

                this.alertService.notify('error', 'error', _error.statusText);
            }
        );

    }

    UpdatePrivacy() {
        this.displayPrivacy = false;
        this.hrservice.GetData('InsertPrivacy').subscribe(
            (data: any) => {
                this.displayPrivacy = false;
            }, _error => {
                this.displayPrivacy = true;
                this.alertService.notify('error', 'error', _error.statusText);
            }
        );
    }

    BindMenuItems() {
        this.menuitems = [
            // {
            //     label: 'Home', routerLink: '/home/dashboard'
            // },

            // {
            //     label: 'Useful Resources',
            //     items: [
            //         { label: 'FAQ', command: () => this.OpenTab() },
            //     ],

            // },
        ];

        if (!environment.production) {
            this.subitems.push({ label: 'Run as different user', icon: 'fa fa-unlock', routerLink: '/dummylogin' });
        }
        this.subitems.push({ label: 'Logout', icon: 'fa fa-sign-out', routerLink: '/logout' });
        this.useritems = [
            {
                label: this.appToken.getLoginUserInfo().EmpName, icon: 'fa fa-user',
                items: this.subitems
            },
        ];

    };
}
